// new Event('OneTrustGroupsUpdated') is triggered in Adobe Launch "Load - OneTrust" rule
export const OT_UPDATED_EVENT_NAME = 'OneTrustGroupsUpdated';
export const OT_ALERT_BOX_CLOSED_COOKIE_NAME = 'OptanonAlertBoxClosed';
export const OT_CONSENT_COOKIE_NAME = 'OptanonConsent';
export const OT_GROUPS = {
  STRICTLY_NECESSARY: '1',
  PERFORMANCE: '2',
  FUNCTIONAL: '3',
};
